import { render, staticRenderFns } from "./ConfigEmail.vue?vue&type=template&id=a111673a&"
import script from "./ConfigEmail.vue?vue&type=script&lang=js&"
export * from "./ConfigEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports